import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const StyledLinkDomWhiteIndustries = styled(Link)({
    cursor: "pointer",
    color: "white",
    textDecoration: "none",
    "&:hover, &:focus, &:active, &.active": {
        textDecoration: "none",
        color: "#C3F0F7"
    }
})

export const StyledLinkDom = styled(Link)({
    textDecoration: "none",
    "&:hover, &:focus, &:active, &:visited": {
      textDecoration: "none",
    },
  })